/**
 * Calculate the Extracted Ion Chromatogram
 * @param chromatogram
 * @param targetMass
 * @param options
 * @returns
 */
export function calculateEic(chromatogram, targetMass, options = {}) {
    const { slotWidth = 1 } = options;
    if (!targetMass) {
        throw new Error('targetMass must be defined and a number or string of comma separated numbers');
    }
    let targetMasses;
    if (typeof targetMass === 'number') {
        targetMasses = [targetMass];
    }
    else if (typeof targetMass === 'string') {
        targetMasses = targetMass.split(/[\t\n\r ,;]+/).map(Number);
    }
    else {
        targetMasses = targetMass;
    }
    for (const mass of targetMasses) {
        if (Number.isNaN(mass)) {
            throw new Error('targetMass must be defined and a number or string of comma separated numbers');
        }
    }
    const halfWidth = slotWidth / 2;
    const ms = chromatogram.getSeries2D('ms');
    const massSpectra = ms.getData();
    const result = new Array(massSpectra.length).fill(0);
    for (const mass of targetMasses) {
        for (let i = 0; i < massSpectra.length; i++) {
            const massSpectrum = massSpectra[i];
            for (let j = 0; j < massSpectrum[0].length; j++) {
                if (Math.abs(massSpectrum[0][j] - mass) <= halfWidth) {
                    result[i] += massSpectrum[1][j];
                }
            }
        }
    }
    return result;
}
//# sourceMappingURL=calculate_eic.js.map